import type { ReactElement } from 'react';
import { cn } from '@fshr/shared-react';

type Props = {
	step: number;
	totalSteps: number;
	additionalClasses?: string | string[] | Record<string, boolean>;
};

export function ProductBookingWidgetProgressBar({
	step,
	totalSteps,
	additionalClasses,
}: Props): ReactElement {
	const percentStep = 100 / totalSteps;
	const leftWidthStyle = { width: `${step * percentStep}%` };
	const rightWidthStyle = { width: `${(totalSteps - step) * percentStep}%` };
	const leftLineClassName = cn('w-full border-t-[2px] border-border-strong', additionalClasses);
	const rightLineClassName = cn('w-full border-t-[2px] border-border-subtle', additionalClasses);

	return (
		<div className="w-full flex flex-row">
			<hr className={leftLineClassName} style={leftWidthStyle} />
			<hr className={rightLineClassName} style={rightWidthStyle} />
		</div>
	);
}
